module.exports = __webpack_public_path__ + "static/media/bbc_sport_live_olympics_36773267_plot.52618d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_sport_live_olympics_36773267_plot.png
// module id = 365
// module chunks = 0